<div class="empty">
  <div class="empty__label">{{'There are no groups defined yet.' | translate}}</div>
  <div class="empty__text">{{'Click button below to create your first group!' | translate}}</div>
</div>
